import { PropsWithChildren } from "react";
import { ApplicantMessageContext } from "@certn/utils";

export { ApplicantMessageContext };

export function ApplicantMessagesProvider(props: PropsWithChildren) {
  return (
    <ApplicantMessageContext.Provider value={{ showApplicantMessages: true }}>
      {props.children}
    </ApplicantMessageContext.Provider>
  );
}
